module.exports = __webpack_public_path__ + "static/media/notifications-not-found.ee5d21e8.svg";